<template>
  <el-dialog
    title="Agregar jornada"
    :visible.sync="visible"
    width="70%"
    :before-close="handleClose"
  >
    <el-form
      :model="resource"
      ref="addRecordsForm"
    >
      <el-form-item
        label="Empleado"
        label-width="120px"
        prop="employee.id"
        :rules="[{ required: true, message: 'Campo requerido' }]"
      >
        <el-select
          v-model="resource.employee.id"
          filterable
          remote
          reserve-keyword
          placeholder="Nombre, Cédula o Código"
          :remote-method="employeeSearch"
          :loading="employee_loading"
        >
          <el-option
            v-for="item in employees"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="Fecha"
        label-width="120px"
        prop="date"
        required
        :rules="[{ required: true, message: 'Campo requerido' }]"
      >
        <el-date-picker
          v-model="resource.date"
          format="yyyy-MM-dd"
          :picker-options="{ firstDayOfWeek: 1 }"
          placeholder="Fecha"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item
        label="Entrada"
        label-width="120px"
      >
        <el-row>
          <el-col :span="9">
            <el-time-picker
              v-model="resource.start_time"
              type="fixed-time"
              placeholder="Hora"
            >
            </el-time-picker>
          </el-col>
          <el-col :span="11">
            <el-radio-group
              v-model="resource.start_record_date"
              size="mini"
            >
              <el-radio-button
                v-model="resource.start_record_date"
                label="prev_day"
              >&lt; anterior</el-radio-button>
              <el-radio-button
                v-model="resource.start_record_date"
                label="same_day"
              >mismo día</el-radio-button>
              <el-radio-button
                v-model="resource.start_record_date"
                label="next_day"
              >siguiente &gt;</el-radio-button>
            </el-radio-group>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item
        label="Salida"
        label-width="120px"
      >
        <el-row>
          <el-col :span="9">
            <el-time-picker
              v-model="resource.end_time"
              type="fixed-time"
              placeholder="Hora"
            >
            </el-time-picker>
          </el-col>
          <el-col :span="11">
            <el-radio-group
              v-model="resource.end_record_date"
              size="mini"
            >
              <el-radio-button
                v-model="resource.end_record_date"
                label="prev_day"
              >&lt; anterior</el-radio-button>
              <el-radio-button
                v-model="resource.end_record_date"
                label="same_day"
              >mismo día</el-radio-button>
              <el-radio-button
                v-model="resource.end_record_date"
                label="next_day"
              >siguiente &gt;</el-radio-button>
            </el-radio-group>
          </el-col>
        </el-row>
      </el-form-item>

      <el-form-item
        v-if="this.$auth.config.setCostCenterOnManualRecords || false"
        label="Centro de Costo"
        label-width="120px"
        prop="cost_center_id"
      >
        <el-select
          v-model="resource.cost_center_id"
          filterable
          clearable
          placeholder="Centro de Costo"
        >
          <el-option
            v-for="item in cost_centers"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="handleClose">Cancelar</el-button>
      <el-button
        type="primary"
        @click="handleSubmit"
      >Confirmar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { getOptionLabel } from "../../utils/lib";

export default {
  name: "workday-add",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    filters: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      // devices: {},
      baseUrl: "/reports/dailyattendancedetails",
      shiftsByFunctionalArea: [],
      shifts: [],
      resource: {
        // prev_records: null,
        // records: null,
        // next_records: null,
        start_time: null,
        end_time: null,
        employee: {
          id: null,
          company_id_number: null,
          name: null,
        },
        shift_id: null,
        date: null,
        start_record_date: "same_day",
        end_record_date: "same_day",
        computed: null,
        cost_center_id: null,
      },
      edit: false,
      employee_loading: false,
      employees: [],
      employees_from_db: [],
      last_employee_search: null,
    };
  },
  computed: {
    ...mapGetters(["cost_centers"]),
  },
  mounted() {
    this.fetchCostCenters();
  },
  methods: {
    ...mapActions(["fetchCostCenters"]),
    addManualRecords() {
      this.resource.records = [];
      this.resource.employee.id = null;
      this.resource.employee.company_id_number = null;
      this.resource.employee.name = null;
      this.resource.date = null;
      this.resource.start_time = null;
      this.resource.end_time = null;
      this.resource.start_record_date = "same_day";
      this.resource.end_record_date = "same_day";
      this.addRecordDialogFormVisible = true;
    },
    // datePickerChange() {
    //   let value = this.resource.date;
    //   console.log(value);
    //   this.resource.date = moment(value).format("YYYY-MM-DD");
    // },
    handleClose(tag) {
      this.orderBy.splice(
        _.findIndex(this.orderBy, (elem) => {
          return elem.field === tag.field;
        }),
        1
      );
    },
    handleSubmit: function () {
      this.$refs["addRecordsForm"].validate((valid) => {
        if (valid) {
          // console.log(this.resource);
          //   this.dialogFormVisible = false
          // self = this;
          //   this.clearErrors();
          // console.log(this.resource);
          let dateString = moment(this.resource.date).format("YYYY-MM-DD")
          let res = {
            date: dateString,
          };
          if (this.resource.start_time !== null) {
            // res['in'] = moment(this.resource.start_time).year(dateString.substring(0, 4)).month(dateString.substring(5, 7) - 1).date(dateString.substring(8, 10)).format("YYYY-MM-DD HH:mm:ss");
            let _in = moment(this.resource.start_time);
            if (this.resource.start_record_date === "prev_day") {
              _in
                .year(dateString.substring(0, 4))
                .month(dateString.substring(5, 7) - 1)
                .date(dateString.substring(8, 10))
                .subtract(1, "days");
              // console.log("next_day");
            } else if (this.resource.start_record_date === "next_day") {
              _in
                .year(dateString.substring(0, 4))
                .month(dateString.substring(5, 7) - 1)
                .date(dateString.substring(8, 10))
                .add(1, "days");
              // console.log("next_day");
            } else {
              // console.log("same_day");
              _in
                .year(dateString.substring(0, 4))
                .month(dateString.substring(5, 7) - 1)
                .date(dateString.substring(8, 10));
            }
            // console.log(in);
            res["in"] = _in.format("YYYY-MM-DD HH:mm:ss");
          }
          if (this.resource.end_time !== null) {
            let out = moment(this.resource.end_time);
            if (this.resource.end_record_date === "prev_day") {
              out
                .year(dateString.substring(0, 4))
                .month(dateString.substring(5, 7) - 1)
                .date(dateString.substring(8, 10))
                .subtract(1, "days");
              // console.log("next_day");
            } else if (this.resource.end_record_date === "next_day") {
              out
                .year(dateString.substring(0, 4))
                .month(dateString.substring(5, 7) - 1)
                .date(dateString.substring(8, 10))
                .add(1, "days");
              // console.log("next_day");
            } else {
              // console.log("same_day");
              out
                .year(dateString.substring(0, 4))
                .month(dateString.substring(5, 7) - 1)
                .date(dateString.substring(8, 10));
            }
            // console.log(out);
            res["out"] = out.format("YYYY-MM-DD HH:mm:ss");
          }
          if (this.resource.cost_center_id !== null) {
            res["cost_center_id"] = this.resource.cost_center_id;
          }
          // console.log(res);
          axios
            .post(
              "/api/employees/" +
              this.resource.employee.id +
              "/recordsoverride",
              res
            )
            .then((response) => {
              // console.log(response);
              // this.$router.push(self.baseUrl);
              // this.dialogFormVisible = false;
              // this.addRecordDialogFormVisible = false;
              // this.$refs.dataTable.fetchItems();
              this.$emit("workdayAdded");
            })
            .catch((error) => {
              if (error.response.status == 422) {
                _.each(error.response.data, (value, key) => {
                  this.errors[key] = value.join(", ");
                });
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    employeeSearch(query) {
      query = query.toUpperCase();
      if (query.length > 2) {
        this.employee_loading = true;
        if (
          this.last_employee_search !== null &&
          query.indexOf(this.last_employee_search) == 0
        ) {
          var emp = [];
          _.each(this.employees_from_db, (item) => {
            if (
              item.id_number.toUpperCase().indexOf(query) >= 0 ||
              item.last_name.toUpperCase().indexOf(query) >= 0 ||
              item.first_name.toUpperCase().indexOf(query) >= 0
            ) {
              emp.push({
                label:
                  item.id_number +
                  " - " +
                  item.last_name +
                  ", " +
                  item.first_name,
                value: item.id,
              });
            }
          });
          this.employees = emp;
          this.employee_loading = false;

          // this.employees = this.employees_from_db.filter(item => {
          //     return
          // });
        } else {
          let query_string = `?filter=${query}`;
          if (this.filters.functional_area_id != null) {
            query_string += `&functional_area_id=${this.filters.functional_area_id}`;
          }
          if (this.filters.roster_id != null) {
            query_string += `&roster_id=${this.filters.roster_id}`;
          }
          if (this.filters.labor_agreement_id != null) {
            query_string += `&labor_agreement_id=${this.filters.labor_agreement_id}`;
          }
          axios.get("/api/employees" + query_string).then((response) => {
            this.employees_from_db = [];
            var emp = [];
            _.each(response.data.data, (item) => {
              this.employees_from_db.push({
                id: item.id,
                id_number: item.id_number,
                last_name: item.last_name,
                first_name: item.first_name,
              });
              emp.push({
                label:
                  item.id_number +
                  " - " +
                  item.last_name +
                  ", " +
                  item.first_name,
                value: item.id,
              });
            });
            this.employees = emp;
            this.employee_loading = false;
          });
          this.last_employee_search = query;
        }
      } else {
        this.employees = [];
      }
    },
    handleClose: function () {
      this.$emit("close");
    },
  },
};
</script>
